<template>
  <svg
    :class="{
      'stroke-black dark:stroke-white': !active,
      'stroke-lush-green': active,
      'duration-300': true
    }"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.88867 3H26.1109V27C26.1109 28.1046 25.2155 29 24.1109 29H7.88867C6.7841 29 5.88867 28.1046 5.88867 27V3Z"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <path d="M5.88867 11.6667H26.1109" stroke-width="2" stroke-linecap="round" />
    <path d="M11.6665 17.4443H13.1109" stroke-width="2" stroke-linecap="round" />
    <path d="M18.8887 17.4443H20.3331" stroke-width="2" stroke-linecap="round" />
    <path d="M11.6665 23.2222H13.1109" stroke-width="2" stroke-linecap="round" />
    <path d="M18.8887 23.2222H20.3331" stroke-width="2" stroke-linecap="round" />
  </svg>
</template>

<script setup>
defineProps(['active'])
</script>

<style scoped></style>
